// extracted by mini-css-extract-plugin
export default {"control":"ProfileContent_control__EXT0I","flexContainer":"ProfileContent_flexContainer__BWQpg"};